import { render } from "./forgot-password-form.vue?vue&type=template&id=6c2ab86f"
import script from "./forgot-password-form.vue?vue&type=script&lang=ts"
export * from "./forgot-password-form.vue?vue&type=script&lang=ts"
script.render = render

export default script